import React, { useContext, useState, useEffect, useRef, memo} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Searchbar from '../../components/Searchbar/Searchbar';
import Button from '../../components/Button/Button';
import Filter from "../../components/Filter/Filter";
import Sort from "../../components/Sort/Sort";
import styles from './LeadReview.module.css';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import axios from "axios";
import { CaseContext } from "../CaseContext";
import api from "../../api"; // adjust the path as needed
import SelectLeadModal from "../../components/SelectLeadModal/SelectLeadModal";
import {SideBar } from "../../components/Sidebar/Sidebar";
import { AlertModal } from "../../components/AlertModal/AlertModal";
import { createPortal } from "react-dom";

// Double-encodes '/' so Express routing doesn't split on it.
// Backend uses decodeURIComponent() to restore the original value.
const safeEncode = (str) => encodeURIComponent(str ?? '').replace(/%2F/gi, '%252F');


export const LeadReview = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Grab case details from location.state
  const { caseDetails } = location.state || {};
  const { leadId, leadDescription } = location.state || {};
  const leadEntries = location.state?.leadEntries || [];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pendingRoute, setPendingRoute]   = useState(null);
  const [caseTeam, setCaseTeam] = useState({ detectiveSupervisors: [], caseManagers: [], investigators: [], officers: [] });
  const [originalAssigned, setOriginalAssigned] = useState([]);
  const signedInOfficer = localStorage.getItem("loggedInUser");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [associatedSubCategories, setAssociatedSubCategories] = useState([]);
  const [caseSubCategories, setCaseSubCategories] = useState([]); 
  const [aoOpen, setAoOpen] = useState(false);
  const [aoQuery, setAoQuery] = useState("");
  const NO_NUMBER = new Set(["Lead Reopened", "Lead Closed"]);

  const [deleteOpen, setDeleteOpen] = useState(false);
const [deleteReason, setDeleteReason] = useState("");
const [showCloseLeadModal, setShowCloseLeadModal] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
const [confirmTitle, setConfirmTitle] = useState("Confirm");
const [confirmMessage, setConfirmMessage] = useState("");
const confirmResolveRef = useRef(null);

// Decline modal state
const [declineOpen, setDeclineOpen] = useState(false);
const [declineReason, setDeclineReason] = useState("");
const presetReasons = [
  "Not my expertise / outside scope",
  "Insufficient information provided",
  "Unavailable in the given timeframe",
  "Conflict of interest",
  "Assigned to another officer / duplicate"
];



   const [showSelectModal, setShowSelectModal] = useState(false);
  const [leads, setLeads] = useState({
            assignedLeads: [],
            pendingLeads: [],
            pendingLeadReturns: [],
            allLeads: [],
       } );
  const toUsername = (x) => (typeof x === "string" ? x : (x?.username ?? x?.name ?? ""));


  const { selectedCase, setSelectedLead , selectedLead, leadStatus, setLeadStatus} = useContext(CaseContext);
  const statuses = [
    "Lead Created",
    "Lead Assigned",
    "Lead Accepted",
    "Lead Return Submitted",
    "Lead Approved",
    "Lead Returned",
    "Lead Completed",
    "Lead Reopened",
    "Lead Closed"
  ];

  const statusToIndex = {
    Assigned:               1,
    "To Reassign": 1, 
    Accepted:                2,  // maps to "Lead Accepted"
    "In Review":            3,  // if you also use "In Review"
    Submitted:              3,  // or map your own submission status here
    Approved:               4,  // "Lead Approved"
    Returned:               5,  // "Lead Returned"
    Reopened: 7,
    Completed:              6,  // "Lead Completed"
  };

  const isInvestigator = selectedCase?.role === "Investigator";
const [allUsers, setAllUsers] = useState([]);
  const toTitleCase = (s = "") =>
  s.replace(/\w\S*/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase());

  // const assOff= useRef(null);
  //  useEffect(() => {
  //     function handleClickOutside(e) {
  //       if (assOff.current && !assOff
  //         .current.contains(e.target)) {
  //         setDropdownOpen(false);
  //       }
       
  //     }
    
  //     document.addEventListener("mousedown", handleClickOutside);
  //     return () => document.removeEventListener("mousedown", handleClickOutside);
  //   }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // display helper — "Last, First (username) (title)" — used in dropdowns
const fmtUser = (u) => {
  if (!u) return "";
  const last  = (u.lastName  || "").trim();
  const first = (u.firstName || "").trim();
  const name  = last && first ? `${last}, ${first}` : last || first || "";
  const uname = u.username ? ` (${u.username})` : "";
  const title = u.title    ? ` (${u.title})`    : "";
  return name ? `${name}${uname}${title}` : u.username || "";
};
// display helper — "Last, First (username)" — used for on-screen officer display
const fmtUserDisplay = (u) => {
  if (!u) return "";
  const last  = (u.lastName  || "").trim();
  const first = (u.firstName || "").trim();
  const name  = last && first ? `${last}, ${first}` : last || first || "";
  const uname = u.username ? ` (${u.username})` : "";
  return name ? `${name}${uname}` : u.username || "";
};
const displayUserAO = (uname) => {
  const u = allUsers.find((x) => x.username === uname);
  return u ? fmtUserDisplay(u) : (uname || "");
};

const DELETE_REASON_CHIPS = [
  "Duplicate lead",
  "Created in error",
  "No longer relevant",
  "Merged with another lead",
  "Case closed",
];

const CLOSE_REASON_CHIPS = [
  "Investigation completed - all leads exhausted",
  "Insufficient evidence to proceed",
  "Case resolved through other means",
  "Duplicate of another lead",
  "No longer relevant to case objectives",
];

const CloseReasonModal = memo(function CloseReasonModal({ open, onCancel, onSubmit }) {
  const [text, setText] = useState("");
  useEffect(() => { if (open) setText(""); }, [open]);
  if (!open) return null;
  const canSubmit = (text || "").trim().length >= 5;
  const body = (
    <div className={styles.modalBackdrop} onClick={onCancel}>
      <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Delete Lead</h3>
          <button onClick={onCancel} aria-label="Close" className={styles.modalClose}></button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.modalSubtitle}>Please provide a reason for closing</div>
          <div className={styles.chipGroup}>
            {CLOSE_REASON_CHIPS.map((chip) => {
              const active = text === chip;
              return (
                <button
                  key={chip}
                  onClick={() => setText(active ? "" : chip)}
                  className={`${styles.chip} ${active ? styles.chipActive : ""}`}
                >
                  {chip}
                </button>
              );
            })}
          </div>
          <textarea
            className={styles.modalTextarea}
            placeholder="Type a brief reason for closing this lead (required)…"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <div className={styles.modalActions}>
            <button onClick={onCancel} className={styles.modalCancelBtn}>Cancel</button>
            <button
              onClick={() => { const r = text.trim(); if (r.length >= 5) onSubmit(r); }}
              disabled={!canSubmit}
              className={`${styles.modalDeleteBtn} ${!canSubmit ? styles.modalDeleteBtnDisabled : ""}`}
            >
              Delete Lead
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  return createPortal(body, document.getElementById("modal-root") || document.body);
});

const DeleteReasonModal = memo(function DeleteReasonModal({ open, onCancel, onSubmit }) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (open) setText("");
  }, [open]);

  if (!open) return null;

  const canSubmit = (text || "").trim().length >= 3;

  const body = (
    <div className={styles.modalBackdrop} onClick={onCancel}>
      <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Delete Lead</h3>
          <button onClick={onCancel} aria-label="Close" className={styles.modalClose}>✕</button>
        </div>

        {/* Body */}
        <div className={styles.modalBody}>
          <div className={styles.modalSubtitle}>Please provide a reason for deletion</div>

          {/* Preset chips */}
          <div className={styles.chipGroup}>
            {DELETE_REASON_CHIPS.map((chip) => {
              const active = text === chip;
              return (
                <button
                  key={chip}
                  onClick={() => setText(active ? "" : chip)}
                  className={`${styles.chip} ${active ? styles.chipActive : ""}`}
                >
                  {chip}
                </button>
              );
            })}
          </div>

          {/* Free-text */}
          <textarea
            className={styles.modalTextarea}
            placeholder="Type a brief reason for deleting this lead (required)…"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          {/* Actions */}
          <div className={styles.modalActions}>
            <button onClick={onCancel} className={styles.modalCancelBtn}>Cancel</button>
            <button
              onClick={() => { const reason = text.trim(); if (reason.length < 3) return; onSubmit(reason); }}
              disabled={!canSubmit}
              className={`${styles.modalDeleteBtn} ${!canSubmit ? styles.modalDeleteBtnDisabled : ""}`}
            >
              Delete Lead
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const root = document.getElementById("modal-root") || document.body;
  return createPortal(body, root);
});
  
  useEffect(() => {
    if (!selectedCase?.caseNo) return;
    const token = localStorage.getItem("token");
    api.get(`/api/cases/${selectedCase.caseNo}/team`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(resp => {
      setCaseTeam({
        detectiveSupervisors: resp.data.detectiveSupervisors || [],
        caseManagers:         resp.data.caseManagers || [],
        investigators:        resp.data.investigators || [],
        officers:             resp.data.officers || [],
      });
    }).catch(console.error);
  }, [selectedCase.caseNo]);

console.log ("case team ====", caseTeam);

// normalize assignedTo items into { username, status }
const normalizeAssignedTo = (arr) =>
  (Array.isArray(arr) ? arr : []).map(x =>
    typeof x === "string" ? { username: x, status: "pending" } : x
  );

// compute the aggregate lead status from per-officer statuses
// const computeLeadStatus = (assigned) => {
//   const list = normalizeAssignedTo(assigned);
//   if (list.length === 0) return "Assigned";
//   const statuses = list.map(a => a.status);
//   const allAccepted = statuses.every(s => s === "accepted");
//   const allDeclined = statuses.every(s => s === "declined");
//   const anyDeclined = statuses.includes("declined");

//   if (allAccepted) return "Accepted";
//   if (allDeclined) return "Rejected";
//   if (anyDeclined) return "To Reassign";
//   return "Assigned";
// };

const computeLeadStatus = (assigned, primaryUser) => {
  const list = normalizeAssignedTo(assigned);

  // ✅ If primary accepted, overall status is Accepted
  if (primaryUser) {
    const pri = list.find(a => a.username === primaryUser);
    if (pri?.status === "accepted") return "Accepted";
  }

  if (list.length === 0) return "Assigned";

  const statuses    = list.map(a => a.status);
  const allAccepted = statuses.every(s => s === "accepted");
  const allDeclined = statuses.every(s => s === "declined");
  const anyDeclined = statuses.includes("declined");

  if (allAccepted)   return "Accepted";
  if (allDeclined)   return "Rejected";
  if (anyDeclined)   return "To Reassign";
  return "Assigned";
};



// const handleSave = async (updatedOfficers = assignedOfficers, updatedLeadData = leadData) => {

//   if (!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")) {
//        setAlertMessage("Unauthorized: Only Case Managers or Detective Supervisors can make changes.");
//        setAlertOpen(true);
//     return;
//   }

//   try {
//     const token = localStorage.getItem("token");
//     setLoading(true);

//     const normalizedParent = typeof updatedLeadData.parentLeadNo === "string"
//       ? updatedLeadData.parentLeadNo
//           .split(",")
//           .map((item) => Number(item.trim()))
//           .filter((num) => !isNaN(num))
//       : updatedLeadData.parentLeadNo;

//     const previousUsernames = originalAssigned;

//     console.log("leadData.assignedTo (raw):", leadData.assignedTo);
//     console.log("previousUsernames:", originalAssigned);
//     console.log("assignedOfficers:", assignedOfficers);

//     const processedAssignedTo = updatedOfficers.map(username => {
//     const existing = Array.isArray(updatedLeadData
//       .assignedTo)
//       ? updatedLeadData
//       .assignedTo.find(item => {
//           const name = typeof item === 'string' ? item : item.username;
//           return name === username;
//         })
//       : null;

//       console.log("existing", existing);
//       return {
//         username,
//         status: existing?.status || "pending"
//       };
//     });

//     const effectivePrimary = updatedLeadData.primaryOfficer || (updatedOfficers.length > 0 ? updatedOfficers[0] : "");

//     const newlyAdded = updatedOfficers
//     .filter(u => !originalAssigned.includes(u));

//      if (newlyAdded.length) {
//        const updatedInvestigators = Array.from(new Set([
//         ...caseTeam.investigators,
//         ...newlyAdded
//       ]));

//        const officers = [
//          ...(caseTeam.detectiveSupervisor
//             ? [{ name: caseTeam.detectiveSupervisor,
//                  role: "Detective Supervisor",
//                  status: "accepted" }]
//             : []),
//           ...caseTeam.caseManagers.map(name => ({
//           name,
//           role:   "Case Manager",
//           status: "accepted"
//          })),
//          ...updatedInvestigators.map(name => ({
//            name,
//            role:   "Investigator",
//            status: "pending"
//          }))
//        ];
//        await api.put(
//          `/api/cases/${encodeURIComponent(selectedCase.caseNo)}/${encodeURIComponent(selectedCase.caseName)}/officers`,
//          { officers },
//          { headers: { Authorization: `Bearer ${token}` } }
//        );
//        // refresh your local caseTeam so the sidebar stays up-to-date
//        const teamResp = await api.get(
//          `/api/cases/${selectedCase.caseNo}/team`,
//          { headers: { Authorization: `Bearer ${token}` } }
//        );
//        setCaseTeam({
//          detectiveSupervisor: teamResp.data.detectiveSupervisor,
//          caseManagers:         teamResp.data.caseManagers,
//          investigators:       teamResp.data.investigators
//        });
//      }

//     for (let username of newlyAdded) {
//       await api.post(
//         "/api/notifications",
//         {
//           notificationId: Date.now().toString(),
//           assignedBy: signedInOfficer,        
//           assignedTo: [{
//             username,
//             role:     "Investigator",           
//             status:   "pending",
//             unread:   true
//           }],
//           action1: "assigned you to a new lead",
//           post1:   `${leadData.leadNo}: ${leadData.description}`,
//           action2:  "related to the case",
//           post2:   `${selectedCase.caseNo}: ${selectedCase.caseName}`,
//           caseNo:   leadData.caseNo,
//           caseName: leadData.caseName,
//           leadNo: leadData.leadNo,
//           leadName: leadData.description,
//           caseStatus: selectedCase.caseStatus || "Open",
//           type: "Lead"
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//     }

 
//     const processedLeadData = {
//       ...updatedLeadData,
//       parentLeadNo: normalizedParent,
//       assignedTo: processedAssignedTo,
//       assignedOfficer: processedAssignedTo.map(a => a.username),
//       primaryOfficer: effectivePrimary || null,
//       primaryInvestigator: effectivePrimary || null,
//       ...(updatedOfficers.length > 0 ? { leadStatus: "Assigned" } : {})
//     };

//     await api.put(
//       `/api/lead/update/${leadData.leadNo}/${encodeURIComponent(leadData.description)}/${leadData.caseNo}/${encodeURIComponent(leadData.caseName)}`,
//       processedLeadData,
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     setLeadData(prev => ({
//     ...prev,
//     ...processedLeadData,
//     assignedTo: processedAssignedTo,        // <�" important
//     primaryOfficer: effectivePrimary || "",
//     }));
//     setOriginalAssigned(processedAssignedTo.map(x => x.username));

//     setAlertMessage("Lead updated successfully!");
//        setAlertOpen(true);
//       } catch (err) {
//         console.error("Save failed:", err);
//         setError("Failed to save changes.");
//       } finally {
//         setLoading(false);
//       }
// };


// const acceptLead = async (leadNo, description) => {
//   console.log("Accept button clicked for lead:", leadNo);

//   try {
//     const token = localStorage.getItem("token");
//     const url = `/api/lead/${leadNo}/${encodeURIComponent(description)}/${selectedCase.caseNo}/${encodeURIComponent(selectedCase.caseName)}`;
//     console.log("PUT request URL:", url);

//     const response = await api.put(
//       url,
//       {}, // backend handles default payload
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     //  await api.post(
//     //   "/api/notifications",
//     //   {
//     //     notificationId: Date.now().toString(),
//     //     assignedBy: signedInOfficer,
//     //     assignedTo: [{
//     //         username: leadData.assignedBy,
//     //         role:     "Case Manager",           
//     //         status:   "pending",
//     //         unread:   true
//     //       }],
//     //     action1: "accepted the lead",
//     //     post1:   `${leadNo}: ${description}`,
//     //     caseNo:   selectedCase.caseNo,
//     //     caseName: selectedCase.caseName,
//     //     leadNo: leadNo,
//     //     leadName: description,
//     //     caseStatus: selectedCase.caseStatus || "Open",
//     //     type: "Lead"
//     //   },
//     //   { headers: { Authorization: `Bearer ${token}` } }
//     // );

//     console.log("PUT request succeeded. Response data:", response.data);

//     // Update UI immediately
//     setLeadData(prev => ({
//       ...prev,
//       leadStatus: "Accepted",
//     }));

//     // alert("✅ Lead accepted successfully!");
//     setAlertMessage("Lead accepted successfully!");
//        setAlertOpen(true);
//   } catch (error) {
//     console.error("Error updating lead status:", error.response?.data || error);
//     // alert("❌ Failed to accept lead.");
//     setAlertMessage("Failed to accept lead.");
//        setAlertOpen(true);
//   }
// };

// const DeclineReasonModal = ({ open, onCancel, onSubmit }) => {
//   if (!open) return null;
//   return (
//     <div className="elog-backdrop" onClick={onCancel}>
//       <div className="elog-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="elog-header">
//           <h3>Reject Lead</h3>
//           <button className="elog-close" onClick={onCancel} aria-label="Close">✕</button>
//         </div>

//         <section className="elog-block">
//           <div className="elog-title">Please provide a reason</div>

//           {/* Quick chips */}
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
//             {presetReasons.map(r => (
//               <button
//                 key={r}
//                 type="button"
//                 className="elog-chip"
//                 onClick={() => setDeclineReason(prev => prev ? `${prev} ${prev.endsWith('.') ? '' : '.'} ${r}` : r)}
//                 title="Use this reason"
//                 style={{ backgroundColor: "#ccc", color: "#000" }}
//               >
//                 {r}
//               </button>
//             ))}
//           </div>

//           {/* Textarea */}
//           <textarea
//             className={styles.inputField}
//             placeholder="Type a brief, professional reason (required)…"
//             value={declineReason}
//             onChange={(e) => setDeclineReason(e.target.value)}
//             style={{ minHeight: 120 }}
//           />

//           <div className="elog-actions" style={{ display: "flex", gap: 12, marginTop: 12, justifyContent: "flex-end" }}>
//             <button className="save-btn1" onClick={onCancel} style={{ background: "#ccc", color: "#000" }}>
//               Cancel
//             </button>
//             <button
//               className="save-btn1"
//               onClick={() => {
//                 const reason = (declineReason || "").trim();
//                 if (reason.length < 5) return setAlertMessage("Please provide a few words explaining why you're declining.");
//                 onSubmit(reason);
//               }}
//               style={{ background: "#e74c3c" }}
//               title="Decline with reason"
//             >
//               Submit
//             </button>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

const DeclineReasonModal = ({ open, onCancel, onSubmit, presetReasons }) => {
  const [localReason, setLocalReason] = useState("");
  const textareaRef = useRef(null);

  // Reset when modal opens/closes
  useEffect(() => {
    if (!open) {
      setLocalReason("");
    }
  }, [open]);

  if (!open) return null;
  
  return (
    <div className={styles.elogBackdrop} onClick={onCancel}>
      <div className={styles.elogModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.elogHeader}>
          <h3>Reject Lead</h3>
          <button className={styles.elogClose} onClick={onCancel} aria-label="Close">✕</button>
        </div>

        <section className={styles.elogBlock}>
          <div className={styles.elogTitle}>Please provide a reason</div>

          {/* Quick chips */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
            {presetReasons.map(r => (
              <button
                key={r}
                type="button"
                className={styles.elogChip}
                onClick={() => {
                  const textarea = textareaRef.current;
                  if (!textarea) {
                    // Fallback if ref not available
                    const current = localReason.trim();
                    if (!current) {
                      setLocalReason(r);
                    } else {
                      const needsPeriod = !current.endsWith('.');
                      setLocalReason(`${current}${needsPeriod ? '.' : ''} ${r}`);
                    }
                    return;
                  }

                  const start = textarea.selectionStart;
                  const end = textarea.selectionEnd;
                  const currentValue = localReason;

                  // Insert at cursor position
                  const before = currentValue.substring(0, start);
                  const after = currentValue.substring(end);
                  
                  // Add spacing if needed
                  const needsSpaceBefore = before.length > 0 && !before.endsWith(' ') && !before.endsWith('.');
                  const needsPeriodBefore = before.length > 0 && !before.endsWith('.') && !before.endsWith(' ');
                  
                  let insertion = r;
                  if (before.length > 0) {
                    if (needsPeriodBefore) {
                      insertion = `. ${r}`;
                    } else if (needsSpaceBefore) {
                      insertion = ` ${r}`;
                    }
                  }

                  const newValue = before + insertion + after;
                  setLocalReason(newValue);

                  // Set cursor position after inserted text
                  setTimeout(() => {
                    const newCursorPos = before.length + insertion.length;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                    textarea.focus();
                  }, 0);
                }}
                title="Click to insert this reason"
                style={{ backgroundColor: "#ccc", color: "#000", cursor: "pointer" }}
              >
                {r}
              </button>
            ))}
          </div>

          {/* Textarea */}
          <textarea
            ref={textareaRef}
            className={styles.inputField}
            placeholder="Type a brief, professional reason (required)…"
            value={localReason}
            onChange={(e) => setLocalReason(e.target.value)}
            style={{ minHeight: 120 }}
            autoFocus
          />

          <div className={styles.elogActions}>
            <button className={styles.saveBtn1} onClick={onCancel} style={{ background: "#ccc", color: "#000" }}>
              Cancel
            </button>
            <button
              className={styles.saveBtn1}
              onClick={() => {
                const trimmedReason = localReason.trim();
                if (trimmedReason.length < 5) {
                  alert("Please provide a few words explaining why you're declining.");
                  return;
                }
                onSubmit(trimmedReason);
              }}
              style={{ background: "#e74c3c" }}
              title="Decline with reason"
            >
              Submit
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};


const handleSave = async (updatedOfficers = assignedOfficers, updatedLeadData = leadData) => {
  if (!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")) {
    setAlertMessage("Unauthorized: Only Case Managers or Detective Supervisors can make changes.");
    setAlertOpen(true);
    return;
  }

  try {
    const token = localStorage.getItem("token");
    setLoading(true);

    // �"� ALWAYS work with usernames (strings)
    const updatedUsernames = (Array.isArray(updatedOfficers) ? updatedOfficers : [])
  .map(toUsername)
  .filter(Boolean);

    // 1) Normalize parentLeadNo
    const normalizedParent = typeof updatedLeadData.parentLeadNo === "string"
      ? updatedLeadData.parentLeadNo.split(",").map(s => Number(s.trim())).filter(n => !isNaN(n))
      : updatedLeadData.parentLeadNo;

    console.log("leadData.assignedTo (raw):", leadData.assignedTo);
    console.log("previousUsernames:", originalAssigned);
    console.log("updatedUsernames:", updatedUsernames);

    // 2) Build assignedTo for the LEAD: [{username, status}]
    const processedAssignedTo = updatedUsernames.map((username) => {
      const existing = Array.isArray(updatedLeadData.assignedTo)
        ? normalizeAssignedTo(updatedLeadData.assignedTo).find((it) => it.username === username)
        : null;
      return { username, status: existing?.status || "pending" };
    });

    const effectivePrimary =
      updatedLeadData.primaryOfficer || (updatedUsernames.length ? updatedUsernames[0] : "");

    // who is newly added (vs original load)
    const newlyAdded = updatedUsernames.filter((u) => !originalAssigned.includes(u));

    // Send lead-assignment notifications for each newly assigned person (exclude DS)
    if (newlyAdded.length) {
      const dsUsernames = (caseTeam.detectiveSupervisors || []).map(toUsername);
      const assignedToEntries = newlyAdded
        .filter((u) => !dsUsernames.includes(u))
        .map((u) => {
          const allTeam = [
            ...(caseTeam.investigators || []).map(toUsername),
            ...(caseTeam.officers || []).map(toUsername),
            ...(caseTeam.caseManagers || []).map(toUsername),
          ];
          const role = (caseTeam.officers || []).map(toUsername).includes(u)
            ? "Officer"
            : allTeam.includes(u)
            ? "Investigator"
            : "Investigator";
          return { username: u, role, status: "pending", unread: true };
        });

      const notificationPayload = {
        notificationId: Date.now().toString(),
        assignedBy: signedInOfficer,
        assignedTo: assignedToEntries,
        action1: "assigned you to a new lead",
        post1: `${updatedLeadData.leadNo}: ${updatedLeadData.description}`,
        action2: "related to the case",
        post2: `${selectedCase.caseNo}: ${selectedCase.caseName}`,
        caseId:   selectedCase._id || selectedCase.id || undefined,
        leadNo:   updatedLeadData.leadNo,
        leadName: updatedLeadData.description,
        caseNo:   selectedCase.caseNo,
        caseName: selectedCase.caseName,
        caseStatus: selectedCase.caseStatus || "Open",
        unread: true,
        type: "Lead",
        time: new Date().toISOString(),
      };

      await api.post(
        "/api/notifications",
        notificationPayload,
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
    }

    // 3) Merge + persist LEAD
    const processedLeadData = {
      ...updatedLeadData,
      parentLeadNo: normalizedParent,
      assignedTo: processedAssignedTo,
      assignedOfficer: processedAssignedTo.map((a) => a.username),
      primaryOfficer: effectivePrimary || null,
      primaryInvestigator: effectivePrimary || null,
      ...(updatedUsernames.length > 0 ? { leadStatus: "Assigned" } : {}),
    };

    await api.put(
      `/api/lead/update/${leadData.leadNo}/${safeEncode(leadData.description)}/${leadData.caseId || selectedCase._id || selectedCase.id}`,
      processedLeadData,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setLeadData((prev) => ({
      ...prev,
      ...processedLeadData,
      assignedTo: processedAssignedTo,
      primaryOfficer: effectivePrimary || "",
    }));

    setOriginalAssigned(processedAssignedTo.map((x) => x.username));

    setAlertMessage("Lead updated successfully!");
    setAlertOpen(true);
  } catch (err) {
    console.error("Save failed:", err);
    setError("Failed to save changes.");
  } finally {
    setLoading(false);
  }
};


// const acceptLead = async (leadNo, description) => {
//   try {
//     const token   = localStorage.getItem("token");
//     const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } };

//     await api.put(
//       `/api/lead/${leadNo}/${encodeURIComponent(description)}/${selectedCase.caseNo}/${encodeURIComponent(selectedCase.caseName)}`,
//       {},
//       headers
//     );

//     const updatedAssignedTo = normalizeAssignedTo(leadData.assignedTo).map(it =>
//       it.username === signedInOfficer ? { ...it, status: "accepted" } : it
//     );

//     const newStatus = computeLeadStatus(updatedAssignedTo);

//     await api.put(
//       `/api/lead/update/${leadData.leadNo}/${encodeURIComponent(leadData.description)}/${leadData.caseNo}/${encodeURIComponent(leadData.caseName)}`,
//       { ...leadData, assignedTo: updatedAssignedTo, leadStatus: newStatus },
//       headers
//     );

//     setLeadData(prev => ({ ...prev, assignedTo: updatedAssignedTo, leadStatus: newStatus }));
//     setLeadStatus?.(newStatus);

//     setAlertMessage(newStatus === "Accepted"
//       ? "All officers accepted. Lead status is 'Accepted'."
//       : "You accepted. Waiting on others �" status stays 'Assigned'."
//     );
//     setAlertOpen(true);
//   } catch (error) {
//     console.error("Error updating lead status:", error.response?.data || error);
//     setAlertMessage("Failed to accept lead.");
//     setAlertOpen(true);
//   }
// };

// const declineLead = async (leadNo, description) => {
//   const token   = localStorage.getItem("token");
//   const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } };

//   try {
//     const updatedAssignedTo = normalizeAssignedTo(leadData.assignedTo).map(it =>
//       it.username === signedInOfficer ? { ...it, status: "declined" } : it
//     );

//     const newStatus = computeLeadStatus(updatedAssignedTo);

//     await api.put(
//       `/api/lead/update/${leadData.leadNo}/${encodeURIComponent(leadData.description)}/${leadData.caseNo}/${encodeURIComponent(leadData.caseName)}`,
//       {
//         ...leadData,
//         assignedTo: updatedAssignedTo,
//         leadStatus: newStatus,
//       },
//       headers
//     );

//     setLeadData(prev => ({ ...prev, assignedTo: updatedAssignedTo, leadStatus: newStatus }));
//     setLeadStatus?.(newStatus);

//     setAlertMessage(
//       newStatus === "Rejected"
//         ? "All officers declined. Lead status set to 'Rejected'."
//         : "You declined. Lead status set to 'To Reassign'."
//     );
//     setAlertOpen(true);
//   } catch (err) {
//     console.error("Error declining lead:", err);
//     setAlertMessage("Failed to decline lead. Please try again.");
//     setAlertOpen(true);
//   }
// };



// who's still "active" = not declined (pending or accepted)
const nonDeclinedUsernames = (assigned) =>
  normalizeAssignedTo(assigned)
    .filter(a => a.status !== "declined")
    .map(a => a.username);

// persist primary safely (bypass handleSave's role guard)
const persistPrimary = async (leadObj, nextPrimary) => {
  const token = localStorage.getItem("token");
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  const payload = {
    ...leadObj,
    primaryInvestigator: nextPrimary || null,
    primaryOfficer:      nextPrimary || null,
  };

  // Persist to your existing update endpoint
  await api.put(
    `/api/lead/update/${leadObj.leadNo}/${safeEncode(leadObj.description)}/${leadObj.caseId || selectedCase._id || selectedCase.id}`,
    payload,
    headers
  );

  // Keep UI in sync immediately
  setLeadData(prev => ({
    ...prev,
    primaryInvestigator: nextPrimary || "",
    primaryOfficer:      nextPrimary || "",
  }));
};

// if exactly one active officer remains, make them primary
const autoPromotePrimaryIfSingleActive = async (leadObj) => {
  const active = nonDeclinedUsernames(leadObj.assignedTo);
  const current = leadObj.primaryInvestigator || leadObj.primaryOfficer || "";

  // If exactly one active remains and it's not already primary �' promote it.
  if (active.length === 1 && active[0] !== current) {
    try {
      await persistPrimary(leadObj, active[0]);
      setAlertMessage(`Primary Investigator set to ${active[0]} automatically.`);
      setAlertOpen(true);
    } catch (e) {
      // Don't block the flow if the server denies �" just log it.
      console.error("Auto-promote primary failed:", e);
    }
  }

  // Optional: if none left active, clear primary
  if (active.length === 0 && current) {
    try {
      await persistPrimary(leadObj, "");
    } catch (e) {
      console.error("Auto-clear primary failed:", e);
    }
  }
};



// const acceptLead = async (leadNo, description) => {
//   try {
//     const token = localStorage.getItem("token");
//     const { data } = await api.put(
//       `/api/lead/lead/${leadNo}/${encodeURIComponent(description)}/${selectedCase.caseNo}/${encodeURIComponent(selectedCase.caseName)}/assignedTo`,
//       { officerUsername: signedInOfficer, status: "accepted" },
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     const lead = data.lead;
//     setLeadData(lead);
//     setLeadStatus?.(lead.leadStatus);

//      await autoPromotePrimaryIfSingleActive(lead);

//     setAlertMessage(
//       lead.leadStatus === "Accepted"
//         ? "All officers accepted. Lead is 'Accepted'."
//         : "You accepted. Waiting on others."
//     );
//     setAlertOpen(true);
//   } catch (error) {
//     console.error("Accept failed:", error.response?.data || error);
//     setAlertMessage("Failed to accept lead.");
//     setAlertOpen(true);
//   }
// };

const acceptLead = async (leadNo, description) => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await api.put(
      `/api/lead/lead/${leadNo}/${safeEncode(description)}/${selectedCase._id || selectedCase.id}/assignedTo`,
      { officerUsername: signedInOfficer, status: "accepted" },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    let lead = data.lead;
    const primary = lead.primaryInvestigator || lead.primaryOfficer;
    const meIsPrimary = signedInOfficer === primary;

    // If I'm primary �' force overall status to Accepted
    if (meIsPrimary && lead.leadStatus !== "Accepted") {
      const headers = { headers: { Authorization: `Bearer ${token}` } };
      const updated = {
        ...lead,
        leadStatus: "Accepted",
      };

      await api.put(
        `/api/lead/update/${lead.leadNo}/${safeEncode(lead.description)}/${lead.caseId || selectedCase._id || selectedCase.id}`,
        updated,
        headers
      );
      lead = updated;
    }

    setLeadData(lead);
    setLeadStatus?.(lead.leadStatus);

    await autoPromotePrimaryIfSingleActive(lead); // keep your existing helper

    setAlertMessage(
  lead.leadStatus === "Accepted"
    ? (meIsPrimary
        ? "Lead accepted by Primary Investigator"
        : "All assignees have accepted this lead")
    : "Acceptance received. Pending responses from remaining assignees."
);
    setAlertOpen(true);
  } catch (error) {
    console.error("Accept failed:", error.response?.data || error);
    setAlertMessage("Failed to accept lead.");
    setAlertOpen(true);
  }
};

const declineLead = async (leadNo, description, reason = "") => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await api.put(
      `/api/lead/lead/${leadNo}/${safeEncode(description)}/${selectedCase._id || selectedCase.id}/assignedTo`,
      { officerUsername: signedInOfficer, status: "declined", reason },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const lead = data.lead;
    setLeadData(lead);
    setLeadStatus?.(lead.leadStatus);

        await autoPromotePrimaryIfSingleActive(lead);


    setAlertMessage(
      lead.leadStatus === "Rejected"
         ? "This lead has been declined by all assigned officers."
    : "You have declined this lead."
    );
    setAlertOpen(true);
  } catch (error) {
    console.error("Decline failed:", error.response?.data || error);
    setAlertMessage("Failed to decline lead.");
    setAlertOpen(true);
  }
};


  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty dates
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Handle invalid dates
  
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-4
    ); // Get last two digits of the year
  
    return `${month}/${day}/${year}`;
  };


  // Default case summary if no data is passed
  const defaultCaseSummary = "";
  // For demonstration, we store lead-related data
  const [leadData, setLeadData] = useState({
    leadNumber: '',
    parentLeadNo: '',
    incidentNo: '',
    subCategory: '',
    associatedSubCategories: [],
    assignedDate: '',
    dueDate: '',
    summary: '',
    assignedBy: '',
    description: '',
    assignedTo: [],
    caseNo: '',
    caseName: "",
    leadStatus: '', 
    assignedTo: [],
    primaryOfficer: '',  
    
  });

  const getCasePageRoute = () => {
    if (!selectedCase || !selectedCase.role) return "/HomePage"; // Default route if no case is selected
    return selectedCase.role === "Investigator" ? "/Investigator" : "/CasePageManager";
};

const [caseDropdownOpen, setCaseDropdownOpen] = useState(true);
const [leadDropdownOpen, setLeadDropdownOpen] = useState(true);
const [leadDropdownOpen1, setLeadDropdownOpen1] = useState(true);

const onShowCaseSelector = (route) => {
  navigate(route, { state: { caseDetails } });
};

console.log("SL, SC", selectedLead, selectedCase);
  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
      const kase = selectedCase?._id || selectedCase?.id ? selectedCase : location.state?.caseDetails;
      let kaseId = kase?._id || kase?.id;

      // Fallback: if _id is missing but caseNo is available, resolve it from the API
      if (!kaseId && kase?.caseNo) {
        try {
          const token = localStorage.getItem("token");
          const { data: caseDoc } = await api.get(`/api/cases/caseNo/${kase.caseNo}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          kaseId = caseDoc?._id;
        } catch (e) {
          console.error("Failed to resolve caseId from caseNo:", e);
        }
      }

      if (lead?.leadNo && lead?.leadName && kaseId) {
        const token = localStorage.getItem("token");

        const response = await api.get(
          `/api/lead/lead/${lead.leadNo}/${safeEncode(lead.leadName)}/${kaseId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
          console.log("Fetched Lead Data1:", response.data);


    //       if (response.data.length > 0) {
    //         setLeadData({
    //           ...response.data[0], 
    //           assignedOfficer: response.data[0].assignedOfficer || [],
    //           assignedTo: response.data[0].assignedTo || [],
    //           leadStatus: response.data[0].leadStatus || '',
    //           primaryOfficer: response.data[0].primaryInvestigator || response.data[0].primaryOfficer || '',
    //         });
    //       }

    //       if (Array.isArray(response.data[0].assignedTo)) {
    //         setOriginalAssigned(
    //           response.data[0].assignedTo.map(item =>
    //             typeof item === "string" ? item : item.username
    //           )
    //         );
    //       // and initialize your "assignedOfficers" checkboxes to match:
    //         setAssignedOfficers(
    //           response.data[0].assignedTo.map(item =>
    //             typeof item === "string" ? item : item.username
    //           )
    //         );

    //         if (response.data[0].primaryInvestigator && !username.includes(response.data[0].primaryInvestigator)) {
    //   setLeadData(prev => ({ ...prev, primaryOfficer: '' }));
    // }

            
    //       }
          
    //     }

   if (response.data.length > 0) {
  const item = response.data[0];
  const assignedNorm = normalizeAssignedTo(item.assignedTo);

   const allUsernames    = assignedNorm.map(x => x.username);
  const activeUsernames = assignedNorm
    .filter(x => x.status !== "declined")
    .map(x => x.username);

  setLeadData({
    ...item,
    assignedOfficer:    item.assignedOfficer    || [],
    assignedTo:         assignedNorm,
    leadStatus:         item.leadStatus || computeLeadStatus(assignedNorm, item.primaryInvestigator || item.primaryOfficer),
    primaryOfficer:     item.primaryInvestigator || "",
    // Normalise fields absent from old documents (created before schema migration)
    incidentNo:         item.incidentNo         ?? '',
    parentLeadNo:       item.parentLeadNo        ?? '',
    subCategory:        item.subCategory         ?? '',
    associatedSubCategories: item.associatedSubCategories ?? [],
  });

  // const assignedUsernames = assignedNorm.map(x => x.username);
  setOriginalAssigned(allUsernames);
  setAssignedOfficers(activeUsernames);

  if (item.primaryInvestigator && !activeUsernames.includes(item.primaryInvestigator)) {
    setLeadData(prev => ({ ...prev, primaryOfficer: "" }));
  }
}

        }
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to fetch lead data.");
      } finally {
        setLoading(false);
      }
    };

    fetchLeadData();
  }, [selectedLead, selectedCase]);

  // useEffect(() => {
  //           // whenever leadData.assignedTo changes, snapshot its original usernames
  //           if (Array.isArray(leadData.assignedTo)) {
  //             setOriginalAssigned(
  //               leadData.assignedTo.map(item =>
  //                 typeof item === "string" ? item : item.username
  //               )
  //             );
  //           }
  //         }, [leadData.assignedTo]);

    // fall back to 0 ("Lead Created") if you get an unexpected value
const currentStatusIndex = statusToIndex[leadData.leadStatus] ?? 0;
const [assignedOfficers, setAssignedOfficers] = useState([]);

const [subcatsLoading, setSubnumsLoading] = useState(false);

useEffect(() => {
  const fetchCaseSubCategories = async () => {
    if (!selectedCase?.caseNo || !selectedCase?.caseName) return;
    try {
      setSubnumsLoading(true);
      const token = localStorage.getItem("token");
      // use the route your backend exposes; adjust if different
      const { data } = await api.get(
        `/api/cases/${selectedCase._id || selectedCase.id}/subCategories`,
        { headers: { Authorization: `Bearer ${token}` }, suppressGlobalError: true }
      );
      // normalize + dedupe
      const subs = Array.from(new Set(data?.subCategories || []));
      setCaseSubCategories(subs);
    } catch (e) {
      console.error("Failed to fetch case subcategories:", e);
      setCaseSubCategories([]); // show "No subcategories" in UI
    } finally {
      setSubnumsLoading(false);
    }
  };
  fetchCaseSubCategories();
}, [selectedCase?.caseNo, selectedCase?.caseName]);

// keep UI selection in sync when lead loads
useEffect(() => {
  if (Array.isArray(leadData?.associatedSubCategories)) {
    setAssociatedSubCategories(leadData.associatedSubCategories);
  }
}, [leadData?.associatedSubCategories]);

      const handleSelectLead = (lead) => {
        setSelectedLead({
          leadNo: lead.leadNo,
          leadName: lead.description,
          caseName: lead.caseName,
          caseNo: lead.caseNo,
        });
      
        setShowSelectModal(false);
        navigate(pendingRoute, {
          state: {
            caseDetails: selectedCase,
            leadDetails: lead
          }
        });
        
        setPendingRoute(null);
      };

// useEffect(() => {
//   if (Array.isArray(leadData.assignedTo)) {
//     const usernames = leadData.assignedTo.map(item =>
//       typeof item === "string" ? item : item.username
//     );
//     setAssignedOfficers(usernames);
//   }
// }, [leadData.assignedTo]);

useEffect(() => {
  if (Array.isArray(leadData?.assignedTo)) {
    const usernames = normalizeAssignedTo(leadData.assignedTo)
      .filter(x => x.status !== "declined")
      .map(x => x.username);
    setAssignedOfficers(usernames);
  }
}, [leadData?.assignedTo]);

  // Dropdown states
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subDropdownOpen, setSubDropdownOpen] = useState(false);

  // Navigation and tab states
  const [showSearchBar, setShowSearchBar] = useState(false);

  // Input change handler
  const handleInputChange = (field, value) => {
    // Example: Only allow digits for 'leadNumber'
    if (field === 'leadNumber' && !/^\d*$/.test(value)) {
      // alert("Lead Number must be numeric.");
       setAlertMessage("Lead Number must be numeric.");
       setAlertOpen(true);
      return;
    }
    setLeadData({ ...leadData, [field]: value });
  };

  // Reusable navigation
  const handleNavigation = (route) => {
    navigate(route);
  };

  

  const [caseSummary, setCaseSummary] = useState('' ||  defaultCaseSummary);

  const [isEditing, setIsEditing] = useState(false); // Controls whether the textarea is editable
  useEffect(() => {
   const fetchCaseSummary = async () => {
     try {
       if (selectedCase && selectedCase.caseNo) {
         const token = localStorage.getItem("token");
         const response = await api.get(`/api/cases/summary/${selectedCase.caseNo}`, {
           headers: { Authorization: `Bearer ${token}` }
         });
         // Update case summary if data is received
         console.log("Response data:", response.data);
         if (response.data) {
           setCaseSummary(response.data.summary );
         }
       }
     } catch (error) {
       console.error("Error fetching case summary:", error);
     }
   };

   fetchCaseSummary();
 }, [selectedCase]);

 // somewhere at the top of your component
const dueDateISO = leadData?.dueDate
? leadData.dueDate.slice(0, 10)
: "";



const signedInUserId = localStorage.getItem("userId");
const myAssignment = normalizeAssignedTo(leadData.assignedTo).find(a =>
  signedInUserId && a.userId
    ? String(a.userId) === signedInUserId
    : a.username === signedInOfficer
);
const showDecisionBlock =
  myAssignment?.status === "pending" 
  // &&(selectedCase.role !== "Case Manager" && selectedCase.role !== "Detective Supervisor");
const isManager = ["Case Manager", "Detective Supervisor"].includes(selectedCase?.role);
const isAssigned = !!myAssignment;
const isReadOnly = selectedCase?.role === "Read Only";


const canWorkOnReturn = isAssigned ? (myAssignment.status === "accepted") : isManager;


useEffect(() => {
  const fetchUsers = async () => {
    setError(null);
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const { data } = await api.get("/api/users/usernames", {
          // headers: { Authorization: `Bearer ${token}` }
        });
        setAllUsers(data.users || []);
    } catch (err) {
      console.error("❌ Error fetching users:", err);
      setError("Could not load user list");
    } finally {
      setLoading(false);
    }
  };

  fetchUsers();
}, []);

const isEditableByCaseManager = field => {
  const editableFields = [
    "parentLeadNo",        // Lead Origin
    "assignedTo",          // Assigned Officers
    "dueDate",             // Due Date
    "subCategory",           // Subcategory
    "associatedSubCategories", // Associated Subcategories
    "primaryOfficer",
  ];
  return (selectedCase?.role === "Case Manager" || selectedCase?.role === "Detective Supervisor") && editableFields.includes(field);
};

const declinedSet = new Set(
  normalizeAssignedTo(leadData.assignedTo)
    .filter(a => a.status === "declined")
    .map(a => a.username)
);

// filtered users (exclude declined) — only case team members
const filteredUsersAO = React.useMemo(() => {
  const q = aoQuery.trim().toLowerCase();
  const teamUsernames = [
    ...(caseTeam.detectiveSupervisors || []),
    ...(caseTeam.caseManagers || []),
    ...(caseTeam.investigators || []),
    ...(caseTeam.officers || []),
  ].map(u => (typeof u === "string" ? u : u?.username)).filter(Boolean);
  const unique = [...new Set(teamUsernames)];
  const pool = unique
    .map(uname => (allUsers || []).find(u => u.username === uname))
    .filter(u => u && !declinedSet.has(u.username));
  const sort = (arr) => [...arr].sort((a, b) => {
    const la = (a.lastName || "").toLowerCase(), lb = (b.lastName || "").toLowerCase();
    if (la !== lb) return la.localeCompare(lb);
    return (a.firstName || "").toLowerCase().localeCompare((b.firstName || "").toLowerCase());
  });
  if (!q) return sort(pool);
  return sort(pool.filter(u => {
    const a = (u.username || "").toLowerCase();
    const b = (u.firstName || "").toLowerCase();
    const c = (u.lastName || "").toLowerCase();
    return a.includes(q) || b.includes(q) || c.includes(q) || `${b} ${c}`.includes(q);
  }));
}, [caseTeam, allUsers, aoQuery, declinedSet]);

// close on outside click / Esc
useEffect(() => {
  const onDoc = (e) => {
    const el = document.getElementById("assigned-officers-wrap");
    if (el && !el.contains(e.target)) setAoOpen(false);
  };
  const onEsc = (e) => e.key === "Escape" && setAoOpen(false);
  document.addEventListener("mousedown", onDoc);
  document.addEventListener("keydown", onEsc);
  return () => {
    document.removeEventListener("mousedown", onDoc);
    document.removeEventListener("keydown", onEsc);
  };
}, []);

// show/hide the events modal
const [eventsModalOpen, setEventsModalOpen] = useState(false);
const [officerTooltipPos, setOfficerTooltipPos] = useState(null);

// sort once for stable timeline
const eventsSorted = React.useMemo(
  () => [...(leadData?.events || [])].sort((a,b) => new Date(a.at) - new Date(b.at)),
  [leadData?.events]
);

const fmtDT = (d) => {
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleString(); // or customize
};

const describeEvent = (ev) => {
  const to = (ev.to || []).join(", ");
  const pi = ev.primaryInvestigator ? ` (Primary: ${ev.primaryInvestigator})` : "";
  switch (ev.type) {
    case "assigned":            return `Assigned ${to}${pi}`;
    case "accepted":            return `${to} accepted`;
    case "declined":            return `${to} declined${ev.reason ? ` �" Reason: ${ev.reason}` : ""}`;
    case "reassigned-added":    return `Added ${to}${pi}`;
    case "reassigned-removed":  return `Removed ${to}${pi}`;
    default:                    return ev.type;
  }
};
// === helpers (keep your fmtDT) ==============================================
const nameOf = (uname) => {
  const u = allUsers.find((x) => x.username === uname);
  return u ? fmtUser(u) : (uname || "");
};

const plural = (arr, s, p) => (arr && arr.length === 1 ? s : p);

// Build quick lookups for first accept/decline timestamps and reasons
const buildDecisionMaps = (events = []) => {
  const acceptedAt = new Map();
  const declinedAt = new Map();
  const declinedReason = new Map();

  events.forEach(ev => {
    if (!Array.isArray(ev.to)) return;
    if (ev.type === "accepted") {
      ev.to.forEach(u => {
        if (!acceptedAt.has(u)) acceptedAt.set(u, ev.at);
      });
    } else if (ev.type === "declined") {
      ev.to.forEach(u => {
        if (!declinedAt.has(u)) declinedAt.set(u, ev.at);
        if (ev.reason) declinedReason.set(u, ev.reason);
      });
    }
  });
  return { acceptedAt, declinedAt, declinedReason };
};

const sectionTitle = (text) => (
  <div style={{ fontWeight: 700, marginTop: 12, marginBottom: 6 }}>{text}</div>
);

// === replacement modal ======================================================
// Compact, professional assignment log
const LeadEventsModal = ({ open, onClose, events }) => {
  if (!open) return null;

  const evs = Array.isArray(events) ? events : [];
  const assigned   = evs.filter(e => e.type === "assigned");
  const accepted   = evs.filter(e => e.type === "accepted");
  const declined   = evs.filter(e => e.type === "declined");
  const added      = evs.filter(e => e.type === "reassigned-added");
  const removed    = evs.filter(e => e.type === "reassigned-removed");

  const firstAssigned = assigned[0] || null;
  const lastStatus = evs.length ? evs[evs.length - 1].statusAfter : undefined;

  // who accepted/declined (first timestamp per officer)
  const { acceptedAt, declinedAt, declinedReason } = buildDecisionMaps(evs);

  // compute the current assigned set (initial + adds �' removes)
  const assignedSet = (() => {
    const s = new Set(firstAssigned?.to || []);
    // process chronologically
    [...added, ...removed]
      .sort((a, b) => new Date(a.at) - new Date(b.at))
      .forEach(ev => {
        (ev.to || []).forEach(u => {
          if (ev.type === "reassigned-added") s.add(u);
          if (ev.type === "reassigned-removed") s.delete(u);
        });
      });
    return s;
  })();

  const pending = [...assignedSet].filter(
    u => !acceptedAt.has(u) && !declinedAt.has(u)
  );

  // message per event (short & professional)
  const msg = (ev) => {
    const people = (ev.to || []).map(nameOf).join(", ") || "";
    switch (ev.type) {
      case "assigned":
        return `Assigned to ${people}` +
          (ev.primaryInvestigator ? ` • Primary: ${nameOf(ev.primaryInvestigator)}` : "");
      case "accepted":
        return `${people} accepted`;
      case "declined":
        return `${people} declined` + (ev.reason ? ` • ${ev.reason}` : "");
      case "reassigned-added":
        return `Added ${people}` +
          (ev.primaryInvestigator ? ` • Primary: ${nameOf(ev.primaryInvestigator)}` : "");
      case "reassigned-removed":
        return `Removed ${people}`;
      default:
        return ev.type || "";
    }
  };

  // icon + tone per event
  const iconFor = (t) =>
    t === "accepted" ? "✓" :
    t === "declined" ? "✕" :
    t === "reassigned-added" ? "+" :
    t === "reassigned-removed" ? "−" : "●";

  const toneFor = (t) =>
    t === "accepted" ? "ok" :
    t === "declined" ? "bad" :
    t === "reassigned-added" ? "info" :
    t === "reassigned-removed" ? "muted" : "base";

  // sorted stream for the timeline
  const stream = [...evs].sort((a,b) => new Date(a.at) - new Date(b.at));

  const toneStyle = {
    ok:    styles.elogToneOk,
    bad:   styles.elogToneBad,
    info:  styles.elogToneInfo,
    muted: styles.elogToneMuted,
    base:  styles.elogToneBase,
  };

  return (
    <div className={styles.elogBackdrop} onClick={onClose}>
      <div className={styles.elogModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.elogHeader}>
          <h3>Assignment Log</h3>
          <div className={styles.elogChip}>{lastStatus || ""}</div>
          <button className={styles.elogClose} onClick={onClose} aria-label="Close">✕</button>
        </div>

        {/* SUMMARY */}
        <section className={styles.elogBlock}>
          <div className={styles.elogCounters}>
            <span className={`${styles.elogCounter} ${styles.elogCounterOk}`}>Accepted {acceptedAt.size}</span>
            <span className={`${styles.elogCounter} ${styles.elogCounterBad}`}>Declined {declinedAt.size}</span>
            <span className={`${styles.elogCounter} ${styles.elogCounterBase}`}>Pending {pending.length}</span>
          </div>
        </section>

        {/* TIMELINE */}
        <section className={styles.elogBlock}>
          <div className={styles.elogTitle}></div>
          {stream.length === 0 ? (
            <div className={styles.elogMuted}>No activity yet.</div>
          ) : (
            <ul className={styles.elogList}>
              {stream.map((ev, i) => (
                <li key={i} className={`${styles.elogItem} ${toneStyle[toneFor(ev.type)] || styles.elogToneBase}`}>
                  <div className={styles.elogPin}>{iconFor(ev.type)}</div>
                  <div className={styles.elogBody}>
                    <div className={styles.elogLine}>{msg(ev)}</div>
                    <div className={styles.elogMeta}>
                      by <b>{nameOf(ev.by)}</b> • {fmtDT(ev.at)}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
};



// centralizes how we change assigned officers
const updateAssignedOfficers = async (nextUsernames) => {
  // keep current primary if still present, otherwise first selected
  const nextPrimary = nextUsernames.includes(leadData.primaryOfficer)
    ? leadData.primaryOfficer
    : (nextUsernames[0] || "");

  // update local UI immediately
  setAssignedOfficers(nextUsernames);
  setLeadData(prev => ({
    ...prev,
    // temporarily store usernames (handleSave will normalize to {username,status})
    assignedTo: nextUsernames,
    primaryOfficer: nextPrimary,
    leadStatus: nextUsernames.length > 0 ? "Assigned" : prev.leadStatus
  }));

  // persist
  try {
    await handleSave(
      nextUsernames,
      { ...leadData, primaryOfficer: nextPrimary, ...(nextUsernames.length ? { leadStatus: "Assigned" } : {}) }
    );
  } catch (err) {
    console.error("Error during auto-save:", err);
    setAlertMessage("An error occurred while updating assigned officers. Please try again.");
    setAlertOpen(true);
  }
};

// put near other useStates
const [isGenerating, setIsGenerating] = useState(false);

// helper to attach files for sections that have uploads
const attachFiles = async (items, idFieldName, filesEndpoint) => {
  return Promise.all(
    (items || []).map(async (item) => {
      const realId = item[idFieldName];
      if (!realId) return { ...item, files: [] };
      try {
        const { data: filesArray } = await api.get(
          `${filesEndpoint}/${realId}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        return { ...item, files: filesArray };
      } catch (err) {
        console.error(`Error fetching files for ${filesEndpoint}/${realId}:`, err);
        return { ...item, files: [] };
      }
    })
  );
};

const handleViewLeadReturn = async () => {
  const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
  const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;

  const kaseId = kase?._id || kase?.id;
  if (!lead?.leadNo || !(lead.leadName || lead.description) || !kaseId) {
    setAlertMessage("Please select a case and lead first.");
    setAlertOpen(true);
    return;
  }

  if (isGenerating) return;

  try {
    setIsGenerating(true);

    const token = localStorage.getItem("token");
    const headers = { headers: { Authorization: `Bearer ${token}` } };

    const { leadNo } = lead;
    const leadName = lead.leadName || lead.description;
    const encLead = safeEncode(leadName);

    // fetch everything we need for the report (same endpoints you use on LRFinish)
    const [
      instrRes,
      returnsRes,
      personsRes,
      vehiclesRes,
      enclosuresRes,
      evidenceRes,
      picturesRes,
      audioRes,
      videosRes,
      scratchpadRes,
      timelineRes,
    ] = await Promise.all([
      api.get(`/api/lead/lead/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/leadReturnResult/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrperson/lrperson/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrvehicle/lrvehicle/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrenclosure/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrevidence/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrpicture/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lraudio/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/lrvideo/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/scratchpad/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
      api.get(`/api/timeline/${leadNo}/${encLead}/${kaseId}`, headers).catch(() => ({ data: [] })),
    ]);

    // add files where applicable (note the plural file endpoints)
    const enclosuresWithFiles = await attachFiles(enclosuresRes.data, "_id", "/api/lrenclosures/files");
    const evidenceWithFiles   = await attachFiles(evidenceRes.data,   "_id", "/api/lrevidences/files");
    const picturesWithFiles   = await attachFiles(picturesRes.data,   "pictureId", "/api/lrpictures/files");
    const audioWithFiles      = await attachFiles(audioRes.data,      "audioId",   "/api/lraudio/files");
    const videosWithFiles     = await attachFiles(videosRes.data,     "videoId",   "/api/lrvideo/files");

    const leadInstructions = instrRes.data?.[0] || {};
    const leadReturns      = returnsRes.data || [];
    const leadPersons      = personsRes.data || [];
    const leadVehicles     = vehiclesRes.data || [];
    const leadScratchpad   = scratchpadRes.data || [];
    const leadTimeline     = timelineRes.data || [];

    // make all sections true (Full Report)
    const selectedReports = {
      FullReport: true,
      leadInstruction: true,
      leadReturn: true,
      leadPersons: true,
      leadVehicles: true,
      leadEnclosures: true,
      leadEvidence: true,
      leadPictures: true,
      leadAudio: true,
      leadVideos: true,
      leadScratchpad: true,
      leadTimeline: true,
    };

    const body = {
      user: localStorage.getItem("loggedInUser") || "",
      reportTimestamp: new Date().toISOString(),

      // sections (values are the fetched arrays/objects)
      leadInstruction: leadInstructions,
      leadReturn:      leadReturns,
      leadPersons,
      leadVehicles,
      leadEnclosures:  enclosuresWithFiles,
      leadEvidence:    evidenceWithFiles,
      leadPictures:    picturesWithFiles,
      leadAudio:       audioWithFiles,
      leadVideos:      videosWithFiles,
      leadScratchpad,
      leadTimeline,

      // also send these two, since your backend expects them
      selectedReports,
      leadInstructions,
      leadReturns,
    };

    const resp = await api.post("/api/report/generate", body, {
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    });

    const file = new Blob([resp.data], { type: "application/pdf" });

    navigate("/DocumentReview", {
      state: {
        pdfBlob: file,
        filename: `Lead_${leadNo || "report"}.pdf`,
      },
    });
  } catch (err) {
    if (err?.response?.data instanceof Blob) {
      const text = await err.response.data.text();
      console.error("Report error:", text);
      setAlertMessage("Error generating PDF:\n" + text);
    } else {
      console.error("Report error:", err);
      setAlertMessage("Error generating PDF:\n" + (err.message || "Unknown error"));
    }
    setAlertOpen(true);
  } finally {
    setIsGenerating(false);
  }
};

// who is primary for this lead?
const primaryUsername =
  leadData?.primaryInvestigator || leadData?.primaryOfficer || "";

// am I the primary investigator on this lead?
const isPrimaryInvestigator =
  selectedCase?.role === "Investigator" &&
  !!signedInOfficer &&
  signedInOfficer === primaryUsername;

// primary goes to the interactive ViewLR page
const goToViewLR = () => {
  const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
  const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;

  if (!lead?.leadNo || !lead?.leadName || !kase?.caseNo || !kase?.caseName) {
    setAlertMessage("Please select a case and lead first.");
    setAlertOpen(true);
    return;
  }

  navigate("/viewLR", {
    state: { caseDetails: kase, leadDetails: lead }
  });
};

const confirmWithModal = (message, title = "Confirm") =>
  new Promise((resolve) => {
    confirmResolveRef.current = resolve;
    setConfirmTitle(title);
    setConfirmMessage(message);
    setConfirmOpen(true);
  });

// const handleDeleteLead = async () => {
//   const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
//   const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;

//   if (!lead?.leadNo || !(lead.leadName || lead.description) || !kase?.caseNo || !kase?.caseName) {
//     setAlertMessage("Please select a case and lead first.");
//     setAlertOpen(true);
//     return;
//   }
//   const ok = await confirmWithModal(
//     `This will permanently delete Lead #${lead.leadNo} �" "${lead.leadName || lead.description}".\n\nAre you sure?`,
//     "Delete Lead"
//   );
//   if (!ok) return;

//   try {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     const encLeadName = safeEncode(lead.leadName || lead.description);
//     const encCaseName = encodeURIComponent(kase.caseName);

//     await api.delete(
//       `/api/lead/${lead.leadNo}/${encLeadName}/${kase.caseNo}/${encCaseName}`,
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     setAlertMessage("Lead deleted successfully.");
//     setAlertOpen(true);

//     const route = selectedCase?.role === "Investigator" ? "/Investigator" : "/CasePageManager";
//     navigate(route, { state: { caseDetails: kase } });
//   } catch (err) {
//     console.error("Delete lead failed:", err?.response?.data || err);
//     setAlertMessage("Failed to delete lead. Please try again.");
//     setAlertOpen(true);
//   } finally {
//     setLoading(false);
//   }
// };


const handleDeleteLead = async () => {
  const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
  const kase = selectedCase?._id || selectedCase?.id ? selectedCase : location.state?.caseDetails;

  if (!lead?.leadNo || !(lead.leadName || lead.description) || !kase?._id && !kase?.id) {
    setAlertMessage("Please select a case and lead first.");
    setAlertOpen(true);
    return;
  }

  // Open the delete-reason modal
  setDeleteReason("");
  setDeleteOpen(true);
};


const submitDeleteWithReason = async (reason) => {
  const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
  const kase = selectedCase?._id || selectedCase?.id ? selectedCase : location.state?.caseDetails;
  const kaseId = kase?._id || kase?.id;

  setDeleteOpen(false);

  try {
    setLoading(true);
    const token = localStorage.getItem("token");
    const encLeadName = safeEncode(lead.leadName || lead.description);

    // Delete the lead (backend appends deletion reason to comments automatically)
    await api.delete(
      `/api/lead/${lead.leadNo}/${encLeadName}/${kaseId}`,
      { headers: { Authorization: `Bearer ${token}` },
    data: { reason } },
    );

    setAlertMessage("Lead deleted successfully.");
    setAlertOpen(true);

    const route = selectedCase?.role === "Investigator" ? "/Investigator" : "/CasePageManager";
    navigate(route, { state: { caseDetails: kase } });
  } catch (err) {
    console.error("Delete lead failed:", err?.response?.data || err);
    setAlertMessage("Failed to delete lead. Please try again.");
    setAlertOpen(true);
  } finally {
    setLoading(false);
  }
};

const handleCloseLead = async (reason) => {
  const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
  const kase = selectedCase?._id || selectedCase?.id ? selectedCase : location.state?.caseDetails;
  const kaseId = kase?._id || kase?.id;

  setShowCloseLeadModal(false);

  try {
    setLoading(true);
    const token = localStorage.getItem("token");
    await api.put(
      `/api/lead/lead/status/close`,
      {
        leadNo:      lead.leadNo,
        description: lead.leadName || lead.description,
        caseId:      kaseId,
        reason,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setLeadStatus("Closed");
    setSelectedLead((prev) => ({ ...prev, leadStatus: "Closed" }));

    const route = selectedCase?.role === "Investigator" ? "/Investigator" : "/CasePageManager";
    navigate(route, { state: { caseDetails: kase } });
  } catch (err) {
    console.error("Close lead failed:", err?.response?.data || err);
    setAlertMessage("Failed to close lead. Please try again.");
    setAlertOpen(true);
  } finally {
    setLoading(false);
  }
};

const assignmentHoverText = React.useMemo(() => {
  const list = normalizeAssignedTo(leadData?.assignedTo);
  if (!list.length) return "No officers assigned.";

  const icon = (s) =>
    s === "accepted" ? "✓" :
    s === "declined" ? "✕" :
    "•"; // pending

  const display = (u) => {
    const m = allUsers.find(x => x.username === u);
    if (!m) return u;
    const full = `${m.firstName || ""} ${m.lastName || ""}`.trim();
    const title = m.title ? ` (${m.title})` : "";
    return full ? `${full}${title} (${m.username})` : m.username;
  };

  // one line per officer
  return list
    .map(({ username, status }) => `${icon(status)} ${display(username)} �" ${status}`)
    .join("\n");
}, [leadData?.assignedTo, allUsers]);



  return (
    <div className={styles.personPage}>

      {/* Navbar */}
      <Navbar />
       <AlertModal
              isOpen={alertOpen}
              title="Notification"
              message={alertMessage}
              onConfirm={() => setAlertOpen(false)}
              onClose={()   => setAlertOpen(false)}
            />

         <DeleteReasonModal
  open={deleteOpen}
  onCancel={() => setDeleteOpen(false)}
  onSubmit={submitDeleteWithReason}
/>

<CloseReasonModal
  open={showCloseLeadModal}
  onCancel={() => setShowCloseLeadModal(false)}
  onSubmit={handleCloseLead}
/>

            <AlertModal
  isOpen={confirmOpen}
  title={confirmTitle}
  message={confirmMessage}
  // treat Confirm as YES
  onConfirm={() => {
    setConfirmOpen(false);
    confirmResolveRef.current?.(true);
  }}
  // treat Close/X as NO / Cancel
  onClose={() => {
    setConfirmOpen(false);
    confirmResolveRef.current?.(false);
  }}
/>

{/* <DeclineReasonModal
  open={declineOpen}
  onCancel={() => { setDeclineOpen(false); setDeclineReason(""); }}
  onSubmit={async (reason) => {
    try {
      await declineLead(leadData.leadNo, leadData.description, reason);
    } finally {
      setDeclineOpen(false);
      setDeclineReason("");
    }
  }}
/> */}

<DeclineReasonModal
  open={declineOpen}
  onCancel={() => { 
    setDeclineOpen(false); 
    setDeclineReason(""); 
  }}
  onSubmit={async (reason) => {
    try {
      await declineLead(leadData.leadNo, leadData.description, reason);
    } finally {
      setDeclineOpen(false);
      setDeclineReason("");
    }
  }}
  reason={declineReason}
  setReason={setDeclineReason}
  presetReasons={presetReasons}
/>


      {/* Main Container */}
      <div className={styles.LRIContent}>

       <SideBar  activePage="LeadReview" />

        {/* Content Area */}
        <div className={`${styles.leftContentLI} ${(canWorkOnReturn || isReadOnly) ? styles.hasMenu : ""}`}>

          {/* Page Header */}

            {(canWorkOnReturn || isReadOnly) && (
              <div className={styles.topMenuNav}>
                <div className={styles.menuItems}>
                  <span className={`${styles.menuItem} ${styles.menuItemActive}`}>Lead Information</span>

                  {!isReadOnly && (
                    <span className={styles.menuItem} onClick={() => {
                      const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
                      const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;
                      if (lead && kase) {
                        navigate("/LRInstruction", { state: { caseDetails: kase, leadDetails: lead } });
                      } else {
                        setAlertMessage("Please select a case and lead first.");
                        setAlertOpen(true);
                      }
                    }}>Add Lead Return</span>
                  )}

                  {!isReadOnly && (["Case Manager", "Detective Supervisor"].includes(selectedCase?.role)) && (
                    <span
                      className={styles.menuItem}
                      onClick={() => {
                        const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
                        const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;
                        if (lead && kase) navigate("/ManageLeadReturn", { state: { caseDetails: kase, leadDetails: lead } });
                      }}
                      title="Manage Lead Return"
                    >
                      Manage Lead Return
                    </span>
                  )}

                  {isReadOnly && (
                    <span
                      className={styles.menuItem}
                      onClick={() => {
                        const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
                        const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;
                        if (lead && kase) navigate("/ManageLeadReturn", { state: { caseDetails: kase, leadDetails: lead } });
                      }}
                      title="View Lead Return"
                    >
                      View Lead Return
                    </span>
                  )}

                  <span className={styles.menuItem} onClick={() => {
                    const lead = selectedLead?.leadNo ? selectedLead : location.state?.leadDetails;
                    const kase = selectedCase?.caseNo ? selectedCase : location.state?.caseDetails;
                    if (lead && kase) {
                      navigate("/ChainOfCustody", { state: { caseDetails: kase, leadDetails: lead } });
                    } else {
                      setAlertMessage("Please select a case and lead first.");
                      setAlertOpen(true);
                    }
                  }}>Lead Chain of Custody</span>
                </div>
              </div>
            )}

        {/* Info bar: breadcrumb + status */}
        <div className={styles.caseandleadinfo}>
          <h5 className={styles.sideTitle}>
            <div className={styles.ldHead}>
              <span className={styles.crumb} style={{ cursor: "pointer" }} onClick={() => (localStorage.getItem("systemRole") || localStorage.getItem("role")) === "Admin" ? navigate("/AdminTeam") : navigate("/HomePage")}>PIMS Home</span>
              <span className={styles.sep}>{" >> "}</span>
              <Link to={getCasePageRoute()} state={{ caseDetails: selectedCase }} className={styles.crumb}>
                Case: {selectedCase?.caseNo || ""}
              </Link>
              <span className={styles.sep}>{" >> "}</span>
              <span className={styles.crumbCurrent} aria-current="page">
                Lead: {selectedLead?.leadNo || ""}
              </span>
            </div>
          </h5>
          <h5 className={styles.sideTitle}>
            {leadData.leadStatus ? `Lead Status: ${leadData.leadStatus}` : ""}
          </h5>
        </div>

        {/* Scrollable content */}
        <div className={styles.lriContentSection}>

{/* {showDecisionBlock && (
    <div
    className="accept-reject-section"
    style={{
      marginTop: "8px",
      marginBottom: "8px",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "#f9f9f9",
    }}
  >
    <h3>
      Do you want to Accept / Reject this lead?
    </h3>
    <div style={{ display: "flex", gap: "20px" }}>
      <button
        className="save-btn1"
        onClick={() => acceptLead(leadData.leadNo, leadData.description)}
      >
        Accept
      </button>

     <button
  style={{ backgroundColor: "#e74c3c", color: "#fff", fontSize: "20px" }}
  onClick={() => setDeclineOpen(true)}
>
  Reject
</button>
    </div>
  </div>
)} */}

{showDecisionBlock && (
  <div className={styles.acceptRejectSection}>
    <div className={styles.acceptanceHead}>
    <h3 className={styles.decisionTitle}>Do you want to Accept / Reject this lead?</h3>
    </div>

    <div className={styles.decisionActions}>
      <button
        className={styles.btnAccept}
        onClick={() =>
          acceptLead(leadData.leadNo, leadData.description)
        }
      >
        Accept
      </button>

      <button
        className={styles.btnReject}
        onClick={() => setDeclineOpen(true)}
      >
        Reject
      </button>
    </div>
  </div>
)}




          {/* Additional Lead Details (Bottom Table) */}
          <div className={styles.formAndTracker}>
          <div className={styles.formCard}>

            {/* Card header – CoC style */}
            <div className={styles.cardHeader}>
              <div className={styles.cardHeaderLeft}>
                <h1 className={styles.cardTitle}>
                  {selectedLead?.leadNo
                    ? `Lead #${selectedLead.leadNo}: ${toTitleCase(selectedLead?.leadName || "")}`
                    : "LEAD DETAILS"}
                </h1>
              </div>
              {(selectedCase?.role === "Case Manager" || selectedCase?.role === "Detective Supervisor") && (
                <button className={styles.deleteBtn} onClick={() => setShowCloseLeadModal(true)} title="Delete this lead">
                  Delete Lead
                </button>
              )}
            </div>

            {/* Summary strip – non-editable key fields */}
            <div className={styles.summaryTableWrap}>
              <table className={styles.summaryTable}>
                <thead>
                  <tr>
                    <th>Assigned By</th>
                    <th>Assigned Date</th>
                    <th>Case Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{leadData.assignedBy ?? "—"}</td>
                    <td>{formatDate(leadData.assignedDate) || "—"}</td>
                    <td>{leadData.caseName ?? "—"}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className={styles.formGrid}>
              <div className={`${styles.formRow} ${styles.formRowHighlight}`}>
                <div className={styles.fieldGroup}>
                  <span className={styles.fieldLabel}>Lead Instruction</span>
                  <div className={styles.leadInstructionText}>{leadData.summary || '—'}</div>
                </div>
              </div>
              <div className={`${styles.formRow} ${styles.formRowEditable}`}>
                <div className={`${styles.fieldGroup} ${styles.fieldGroupBorder}`}>
                  <span className={`${styles.fieldLabel} ${styles.fieldLabelEditable}`}>Lead Origin</span>
                  <input type="text" className={styles.inputField} value={leadData.parentLeadNo} placeholder="NA"
                    readOnly={!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")}
                    onChange={(e) => setLeadData((prev) => ({ ...prev, parentLeadNo: e.target.value }))}
                  />
                </div>
                <div className={styles.fieldGroup}>
                  <span className={`${styles.fieldLabel} ${styles.fieldLabelEditable}`}>Due Date</span>
                  <input type="date" className={styles.inputField} value={dueDateISO}
                    onChange={e => { setLeadData({ ...leadData, dueDate: e.target.value }); }}
                    readOnly={!isEditableByCaseManager("dueDate")}
                  />
                </div>
              </div>

              <div className={`${styles.formRow} ${styles.formRowEditable}`}>
                <div className={styles.fieldGroup}>
                  <span className={`${styles.fieldLabel} ${styles.fieldLabelEditable}`}>Assigned Officers</span>
                  {isInvestigator ? (
      <div className={styles.inputDisplay} style={{ cursor: "default" }}>
        {assignedOfficers.map(displayUserAO).join(", ")}
      </div>
    ) : (
      <div id="assigned-officers-wrap" className={styles.invDropdown}>
        <button
          type="button"
          className={styles.inputDisplay}
          onClick={() => setAoOpen(o => !o)}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setAoOpen(o => !o)}
          aria-haspopup="listbox"
          aria-expanded={aoOpen}
          disabled={!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")}
          title={
            assignedOfficers.length
              ? assignedOfficers.map(displayUserAO).join(", ")
              : "Select Officers"
          }
        >
          <span className={styles.invInputLabel}>
            {assignedOfficers.length
              ? assignedOfficers.map(displayUserAO).join(", ")
              : "Select Officers"}
          </span>
          <span className={styles.invCaret} aria-hidden />
        </button>

        {aoOpen && (
          <div className={styles.invOptions} role="listbox" onMouseDown={(e) => e.stopPropagation()}>
            <div className={styles.invSearchWrap}>
              <input
                type="text"
                className={styles.invSearch}
                placeholder="Type to filter officers…"
                value={aoQuery}
                onChange={(e) => setAoQuery(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}
              />
            </div>

            <div className={styles.invList}>
              {filteredUsersAO.length ? (
                filteredUsersAO.map((user) => {
                  const checked = assignedOfficers.includes(user.username);
                  return (
                    <label key={user.username} className={styles.invItem}>
                      <input
                        type="checkbox"
                        value={user.username}
                        checked={checked}
                        disabled={!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")}
                       onChange={async (e) => {
  if (!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor")) return;

  const { checked, value } = e.target;

  // next usernames
  const nextUsernames = checked
    ? [...assignedOfficers, value]
    : assignedOfficers.filter((u) => u !== value);

  // keep existing status if officer was already there
  const prevAssigned = normalizeAssignedTo(leadData.assignedTo);
  const nextAssignedTo = nextUsernames.map((u) => {
    const prev = prevAssigned.find((p) => p.username === u);
    return { username: u, status: prev?.status || "pending" };
  });

  // pick/repair primary
  const nextPrimary =
    nextUsernames.includes(leadData.primaryInvestigator || leadData.primaryOfficer)
      ? (leadData.primaryInvestigator || leadData.primaryOfficer)
      : (nextUsernames[0] || "");

  // update UI immediately
  setAssignedOfficers(nextUsernames);
  setLeadData((prev) => ({
    ...prev,
    assignedTo: nextAssignedTo,
    primaryOfficer: nextPrimary,
    primaryInvestigator: nextPrimary,
    leadStatus: nextUsernames.length ? "Assigned" : prev.leadStatus,
  }));

}}

                      
                      />
                      <span className={styles.invText}>
                        {fmtUser(user)}
                      </span>
                    </label>
                  );
                })
              ) : (
                <div className={styles.invEmpty}>No matches</div>
              )}
            </div>
          </div>
        )}
      </div>
    )}
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.fieldGroup}>
                  <span className={styles.fieldLabel}>Primary Investigator *</span>
                  <select
                    className={styles.inputField}
                    value={leadData.primaryOfficer}
                    disabled={!(selectedCase.role === "Case Manager" || selectedCase.role === "Detective Supervisor") || assignedOfficers.length === 0}
                    onChange={(e) => {
                      setLeadData(prev => ({ ...prev, primaryOfficer: e.target.value }));
                    }}
                  >
                    <option value="" disabled>{assignedOfficers.length ? 'Select Primary' : 'Assign officers first'}</option>
                    {assignedOfficers.map(uName => {
                      const user = allUsers.find(u => u.username === uName);
                      const label = user ? fmtUser(user) : uName;
                      return <option key={uName} value={uName}>{label}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.fieldGroup}>
                  <span className={`${styles.fieldLabel} ${isEditableByCaseManager("subCategory") ? styles.fieldLabelEditable : ""}`}>Subcategory</span>
                  <input
                    type="text"
                    className={styles.inputField}
                    value={leadData.subCategory}
                    placeholder=""
                    readOnly={!isEditableByCaseManager("subCategory")}
                    onChange={(e) => handleInputChange('subCategory', e.target.value)}
                  />
                </div>
              </div>
              <div className={`${styles.formRow} ${styles.formRowEditable}`}>
                <div className={styles.fieldGroup}>
                  <span className={`${styles.fieldLabel} ${styles.fieldLabelEditable}`}>Associated Subcategories</span>
                  {!isEditableByCaseManager("associatedSubCategories") ? (
                    <div className={styles.inputDisplay} style={{ cursor: "default" }}>
                      {associatedSubCategories.length > 0 ? associatedSubCategories.join(", ") : ""}
                    </div>
                  ) : (
                    <div className={styles.customDropdown}>
                      <div className={styles.inputDisplay} onClick={() => setSubDropdownOpen(!subDropdownOpen)}>
                        {associatedSubCategories.length > 0 ? associatedSubCategories.join(", ") : "Select Subcategories"}
                        <span className={styles.dropdownIcon}>{subDropdownOpen ? "▲" : "▼"}</span>
                      </div>
                      {subDropdownOpen && (
                        <div className={styles.dropdownOptions}>
                          {subcatsLoading && <div className={styles.dropdownItem}>Loading…</div>}
                          {!subcatsLoading && (() => {
                            const opts = Array.from(new Set([
                              ...(leadData.subCategory ? [leadData.subCategory] : []),
                              ...caseSubCategories,
                            ]));
                            if (opts.length === 0) return <div className={styles.dropdownItem}>No subcategories for this case</div>;
                            return opts.map((subNum) => (
                              <div key={subNum} className={styles.dropdownItem}>
                                <input type="checkbox" id={`assoc-${subNum}`} value={subNum} checked={associatedSubCategories.includes(subNum)}
                                  onChange={(e) => {
                                    const updated = e.target.checked ? [...associatedSubCategories, subNum] : associatedSubCategories.filter((n) => n !== subNum);
                                    setAssociatedSubCategories(updated);
                                    setLeadData(prev => ({ ...prev, associatedSubCategories: updated }));
                                  }}
                                />
                                <label htmlFor={`assoc-${subNum}`}>{subNum}</label>
                              </div>
                            ));
                          })()}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isEditableByCaseManager("parentLeadNo") && (
              <div className={styles.updateLeadBtn}>
                <button className={styles.saveBtn1} onClick={() => handleSave(assignedOfficers, leadData)}>
                  Save Changes
                </button>
                {error && <div className={styles.error}>{error}</div>}
              </div>
            )}
          </div>


            {/* {canWorkOnReturn && (
            <div className="lead-tracker-container">
              {statuses.map((status, idx) => (
                <div
                  key={idx}
                  className="lead-tracker-row"
                  onClick={() => {
                    if (status === "Lead Return Submitted") handleNavigation("/LRInstruction");
                    if (status === "Lead Created") setEventsModalOpen(true);
                  }}
                  style={{ cursor: status === "Lead Return Submitted" ? "pointer" : "default" }}
                >
      <div className={`status-circle ${idx <= currentStatusIndex ? "active" : ""}`}>
        <span className="status-number">{idx + 1}</span>
      </div>

                  {idx < statuses.length && (
                    <div className={`status-line ${idx < currentStatusIndex ? "active" : ""}`}>
                    </div>
                  )}
                  <div className={`status-text-box ${idx === currentStatusIndex ? "highlighted" : ""}`}>
                    {status}
                  </div>
                </div>
              ))}
            </div>
            
            )} */}

            {(canWorkOnReturn || isReadOnly) && (
  <div className={styles.trackerContainer}>
    <div className={styles.trackerTitle}>Lead Progress</div>
    {statuses.map((status, idx) => {
      const hideNumber = NO_NUMBER.has(status);
      const isAcceptedStep = status === "Lead Accepted";
      const isCompleted = idx < currentStatusIndex;
      const isHighlighted = idx === currentStatusIndex;
      const isLast = idx === statuses.length - 1;
      const isClickable = false;

      const circleClass = [
        styles.statusCircle,
        isCompleted ? styles.statusCircleCompleted : "",
        isHighlighted ? styles.statusCircleActive : "",
      ].join(" ");

      const connectorClass = [
        styles.statusConnectorH,
        isCompleted ? styles.statusConnectorHCompleted : "",
        isHighlighted ? styles.statusConnectorHActive : "",
      ].join(" ");

      const boxClass = [
        styles.statusBox,
        isCompleted ? styles.statusBoxCompleted : "",
        isHighlighted ? styles.statusBoxActive : "",
        isClickable ? styles.statusBoxClickable : "",
      ].join(" ");

      const assignedList = isAcceptedStep ? normalizeAssignedTo(leadData?.assignedTo) : [];

      return (
        <div key={idx} className={styles.trackerItem}>
          {/* Circle */}
          <div className={circleClass}>
            {!hideNumber && (
              <span className={`${styles.statusNumber} ${(isCompleted || isHighlighted) ? styles.statusNumberActive : ""}`}>
                {idx + 1}
              </span>
            )}
          </div>

          {/* Horizontal dash */}
          <div className={connectorClass} />

          {/* Label box – with hover tooltip for Lead Accepted */}
          {isAcceptedStep && assignedList.length > 0 ? (
            <div
              className={boxClass}
              onMouseEnter={e => {
                const r = e.currentTarget.getBoundingClientRect();
                const tooltipWidth = 240;
                const left = Math.max(8, r.right - tooltipWidth);
                setOfficerTooltipPos({ top: r.bottom + 6, left });
              }}
              onMouseLeave={() => setOfficerTooltipPos(null)}
            >
              {status}
            </div>
          ) : (
            <div className={boxClass}>
              {status}
            </div>
          )}
        </div>
      );
    })}
  </div>
)}

{officerTooltipPos && (() => {
  const list = normalizeAssignedTo(leadData?.assignedTo);
  if (!list.length) return null;
  return createPortal(
    <div
      style={{
        position: "fixed",
        top: officerTooltipPos.top,
        left: officerTooltipPos.left,
        zIndex: 9999,
        background: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        boxShadow: "0 4px 20px rgba(41,41,139,0.15)",
        padding: "12px 14px",
        minWidth: 220,
        fontFamily: "Arial, sans-serif",
        pointerEvents: "none",
      }}
    >
      <div className={styles.officerTooltipTitle}>Assigned Officers</div>
      {list.map(({ username, status: os }) => (
        <div key={username} className={styles.officerItem} style={{ marginTop: 6 }}>
          <span className={
            os === "accepted" ? styles.officerIconAccepted :
            os === "declined" ? styles.officerIconDeclined :
            styles.officerIconPending
          }>
            {os === "accepted" ? "✓" : os === "declined" ? "✕" : "•"}
          </span>
          {displayUserAO(username)}
        </div>
      ))}
    </div>,
    document.getElementById("modal-root") || document.body
  );
})()}

            <LeadEventsModal
  open={eventsModalOpen}
  onClose={() => setEventsModalOpen(false)}
  events={eventsSorted}
/>

                </div>

        </div>
        </div>
      </div>
    </div>
  );
};
